import Vue from "vue";
import Vuex from "vuex";

import plan from "./plan/index";
import survey from "./survey/index";
import exam from "./exam/index";

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    plan,
    survey,
    exam,
  },
  state: {
    progress: "",
    loading: false,
  },
});
